import React, { useState } from "react";
import { DocumentTable } from "@/features/documents/components/DocumentTable";
import { DocumentUploadDialog } from "@/features/documents/components/DocumentUploadDialog";
import { usePageFab } from "@/hooks/use-page-fab";
import { Upload } from "lucide-react";
import { H1HeaderCard } from "@/components/layout/h1-header-card";

export function DocumentsPage() {
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

    const handleFabClick = React.useCallback(() => {
        setIsUploadModalOpen(true);
    }, []);

    const fabAction = React.useMemo(
        () => ({
            icon: Upload,
            label: "Upload Documents",
            onClick: handleFabClick,
            color: "primary" as const,
        }),
        [handleFabClick],
    );

    usePageFab(fabAction);

    return (
        <>
            <div className="container mx-auto">
                <H1HeaderCard
                    title="Receipts"
                    subtitle="Review and approve receipts for expense reporting"
                    className="mb-6"
                />

                <DocumentTable />
            </div>

            <DocumentUploadDialog
                open={isUploadModalOpen}
                onOpenChange={setIsUploadModalOpen}
            />
        </>
    );
}
